export default __webpack_public_path__ + "productThumnail.4fbd1d8e.svg";